'use es6';

import { Map as ImmutableMap } from 'immutable';
import { formatToReferencesList } from 'reference-resolvers/lib/formatReferences';
export const formatSubmissionTags = response => {
  const results = formatToReferencesList({
    getId: submissionTag => submissionTag.getIn(['properties', 'hs_object_id', 'value']),
    getLabel: submissionTag => submissionTag.getIn(['properties', 'hs_tag_name', 'value'])
  })(response.get('results'));
  return ImmutableMap({
    count: results.length,
    offset: response.get('offset'),
    hasMore: response.get('hasMore'),
    results,
    total: response.get('total')
  });
};